import { useCallback, useState } from "react";
import { DEFAULT_NAVIGATION, type WorkspaceNavigation, type WorkspaceNavigationController } from "../lib/workspaceNavigation";

/** The portal supplies URL state; standalone previews keep the same navigation in memory. */
export function useBuilderNavigation(controller?: WorkspaceNavigationController) {
  const [local, setLocal] = useState<WorkspaceNavigation>(() => ({ ...DEFAULT_NAVIGATION,
    ...(typeof window !== "undefined" && new URLSearchParams(window.location.search).has("shop-connect") ? { area: "shop" as const, shopSection: "settings" as const } : {}),
  }));
  const update = controller?.update;
  const change = useCallback((patch: Partial<WorkspaceNavigation>, replace?: boolean) => {
    if (update) update(patch, replace);
    else setLocal(current => ({ ...current, ...patch }));
  }, [update]);
  const setArea = useCallback((area: WorkspaceNavigation["area"], replace?: boolean) => change({ area }, replace), [change]);
  const setBlogSection = useCallback((blogSection: WorkspaceNavigation["blogSection"]) => change({ blogSection, blogPostId: null }), [change]);
  const setBlogPostId = useCallback((blogPostId: string | null) => change({ blogPostId }), [change]);
  const setShopSection = useCallback((shopSection: WorkspaceNavigation["shopSection"]) => change({ shopSection, shopProductId: null, shopOrderId: null }), [change]);
  const setShopProductId = useCallback((shopProductId: string | null) => change({ shopProductId }), [change]);
  const setShopOrderId = useCallback((shopOrderId: string | null) => change({ shopOrderId }), [change]);
  const setPagePath = useCallback((pagePath: string | null, replace?: boolean) => change({ pagePath }, replace), [change]);
  return { ...(controller?.value ?? local), setArea, setBlogSection, setBlogPostId, setShopSection, setShopProductId, setShopOrderId, setPagePath };
}
